var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10117_41635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 164
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10117_41635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 46,
    width: 62,
    height: 85,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 98.4783,
    width: 45,
    height: 5.91304,
    rx: 2.95652,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 109.565,
    width: 35,
    height: 5.91304,
    rx: 2.95652,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 51.913,
    width: 45,
    height: 41.3913,
    rx: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 46,
    width: 62,
    height: 85,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 98.4784,
    width: 45,
    height: 5.91304,
    rx: 2.95652,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 109.565,
    width: 35,
    height: 5.91304,
    rx: 2.95652,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 51.9132,
    width: 45,
    height: 41.3913,
    rx: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10117_41635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 31,
    width: 62,
    height: 115,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 31.5,
    width: 61,
    height: 114,
    rx: 5.5,
    stroke: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 102,
    width: 45,
    height: 8,
    rx: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 117,
    width: 35,
    height: 8,
    rx: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 39,
    width: 45,
    height: 56,
    rx: 6,
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10117_41635",
    x: 45,
    y: 25,
    width: 78,
    height: 131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10117_41635"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10117_41635",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState3);
export default __webpack_public_path__ + "static/media/EmptyState3.95bca40fd562159a2b67aabeee975818.svg";
export { ForwardRef as ReactComponent };